import { Routes, Route, Link } from "react-router-dom";
import Home from "./Home.js";
import Academy from "./Academy.js";
import University from "./University.js";
import Matchmaker from "./Matchmaker.js";
import Arsenal from "./Arsenal.js";
import Footer from "./Footer.js";
import PrivacyPolicy from "./PrivacyPolicy.js";
import "./App.css";

const HomePage = () => (
  <>
    <Home />
    <Academy />
    <University />
    <Matchmaker />
    <Arsenal />
    <Footer />
  </>
);

function App() {
  return (
    <div className="App" style={{ display: "flex", flexDirection: "column" }}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </div>
  );
}

export default App;
